import { render, staticRenderFns } from "./CoralsolDaforForm.vue?vue&type=template&id=235a84a9&scoped=true&"
import script from "./CoralsolDaforForm.vue?vue&type=script&lang=js&"
export * from "./CoralsolDaforForm.vue?vue&type=script&lang=js&"
import style0 from "./CoralsolDaforForm.vue?vue&type=style&index=0&id=235a84a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a84a9",
  null
  
)

export default component.exports